import {Component, OnInit} from '@angular/core';
import {FormArray, FormControl, FormGroup} from '@angular/forms';
import {MessageService} from 'primeng/api';
import {AdminControlService} from '../../@shared/services/admin-control.service';
import {ConfigPanelService} from "../config-panel.service";

@Component({
    selector: 'notification-access-control',
    templateUrl: './notification-access-control.component.html',
    styleUrls: ['./notification-access-control.component.scss']
})
export class NotificationAccessControlComponent implements OnInit {
    isLoading = false;
    notificationConfigList: any;
    notificationConfigListFormArray: FormArray | any = new FormArray([]);

    constructor(
        private configPanelService: ConfigPanelService,
        private messageService: MessageService) {
    }

    ngOnInit(): void {
        this.getNotificationConfigList();
    }


    getNotificationConfigList() {
        this.isLoading = true;
        this.notificationConfigListFormArray = new FormArray([]);
        this.notificationConfigList = null;
        this.configPanelService
            .getNotificationConfigList()
            .subscribe(
                (x) => {
                    this.isLoading = false;
                    this.notificationConfigList = x;
                    this.notificationConfigList?.userNotificationConfigList?.map((res) => {
                        this.addNotificationConfigForm(res);
                    });
                }, (error) => {
                    this.isLoading = false;
                    this.messageService.add({
                        key: 'notification-message',
                        severity: 'error',
                        summary: 'GET : Notification Error !',
                        detail: error?.message ? error?.message : error
                    });
                }
            );
    }

    addNotificationConfigForm(notification?: any) {
        const notificationConfigListForm = new FormGroup({
            userId: new FormControl(notification?.userId ? notification?.userId : ''),
            userName: new FormControl(notification?.userName ? notification?.userName : ''),
            event: new FormControl(notification?.event ? notification?.event : ''),
            isEmailNotificationEnable: new FormControl(notification?.isEmailNotificationEnable ? notification?.isEmailNotificationEnable : false),
            isWhatsAppNotificationEnable: new FormControl(notification?.isWhatsAppNotificationEnable ? notification?.isWhatsAppNotificationEnable : false),
            isInAppNotificationEnable: new FormControl(notification?.isInAppNotificationEnable ? notification?.isInAppNotificationEnable : false),
            notificationId: new FormControl(notification?.notificationId ? notification?.notificationId : '')
        });

        this.notificationConfigListFormArray.push(notificationConfigListForm);
    }

    updateNotificationConfig() {
        this.isLoading = true;
        const notificationConfigPayLoad = this.notificationConfigListFormArray.value;
        const notificationRequestObject = {
            userId: this.notificationConfigList?.userId,
            userName: this.notificationConfigList?.userName,
            userNotificationConfigList: notificationConfigPayLoad

        };
        this.configPanelService
            .updateNotificationConfigList(notificationRequestObject)
            .subscribe((x) => {
                    this.isLoading = false;
                    this.messageService.add({
                        key: 'notification-message',
                        severity: 'info',
                        summary: 'Config Updated !',
                        detail: 'Notification Config updated successfully !'
                    });
                }, (error) => {
                    this.isLoading = false;
                    this.messageService.add({
                        key: 'notification-message',
                        severity: 'error',
                        summary: 'GET : Notification Error !',
                        detail: error?.message ? error?.message : error
                    });
                }
            );

    }
}
